"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPickupPointsFeeRange = void 0;
var _getPickupPointsMaxFee = require("./getPickupPointsMaxFee");
var _getPickupPointsMinFee = require("./getPickupPointsMinFee");
const getPickupPointsFeeRange = (deliveryMethods, lastPickupPointDeliveryFee) => {
  const maxFee = (0, _getPickupPointsMaxFee.getPickupPointsMaxFee)(deliveryMethods);
  const minFee = (0, _getPickupPointsMinFee.getPickupPointsMinFee)(deliveryMethods, lastPickupPointDeliveryFee, maxFee);
  return {
    minFee: minFee === Number.POSITIVE_INFINITY ? undefined : minFee,
    maxFee
  };
};
exports.getPickupPointsFeeRange = getPickupPointsFeeRange;